<template>
    <div class="pageTitle">
        <div class="pageTitle-box">
            <div class="pageTitle-box-icon"
                :style="{ color: iconInfo.color, backgroundColor: iconInfo.bgColor, padding: iconInfo.iconPadding, borderRadius: iconInfo.iconRadius, display: 'flex', alignItems: 'center', justifyContent: 'center' }"
                v-if="iconInfo.icon">
                <icon-svg :icon-class="iconInfo.icon" :size="iconInfo.size" />
            </div>
            <div class="pageTitle-box-text" :style="titleStyle">{{ title }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "pageTitle",
    props: {
        title: {
            type: String,
            default: ''
        },
        titleStyle: {
            type: Object,
            default: () => {
                return {
                    color: '',
                    fontSize: '14px'
                }
            }
        },
        iconInfo: {
            type: Object,
            default: () => {
                return {
                    icon: '',
                    color: '',
                    bgColor: 'var(--base-bg-light-color24)',
                    size: '14px',
                    iconPadding: '10px',
                    iconRadius: '50%'
                }
            }
        }
    },
    data() {
        return {}
    },
    computed: {},
    watch: {},
    created() { },
    mounted() { },
    beforeDestroy() { },
    methods: {}
}
</script>

<style lang="less" scoped>
.pageTitle {

    &-box {
        display: flex;
        align-items: center;
        justify-content: flex-start;

        &-icon {
            margin-right: 16px;
        }
    }
}
</style>